<template>
    <div :class="'emoji-code-' + type" class="emoji-code">
        <img :alt="alt" :aria-label="ariaLabel" :src="emojis[intCode - 1]" :title="alt" v-if="intCode > 0">
    </div>
</template>

<script>
    import emojis from './emojis.js'
    import {getEmojiName, getEmojiPronounciation} from './emoji-names.js'

    export default {
        name: 'single-emoji-code',
        props: {
            code: {
                required: true
            },
            type: {
                type: String,
                required: false,
                default: 'default'
            }
        },
        data() {
            return {
                emojis: emojis
            }
        },
        computed: {
            intCode() {
                return parseInt(this.code, 10)
            },
            alt() {
                return getEmojiName(this.intCode);
            },
            ariaLabel() {
                return getEmojiPronounciation(this.intCode);
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/mixins/mixins.less";

    .emoji-code {
        box-shadow: inset -1px 1px 3px 0px rgba(0, 0, 0, .5);
        width: 65px;
        height: 65px;
        display: inline-block;
        text-align: center;
        background: white;
        margin: 10px;
        border-radius: 10px;
        position: relative;
        .unSelectable();

        &.emoji-code-tiny {
            width: 50px;
            height: 50px;
            margin: 5px;

            img {
            }
        }

        &.emoji-code-large {
            width: 100px;
            height: 100px;
            margin: 25px;
        }

        img {
            position: absolute;

            max-width: 80%;
            max-height: 80%;

            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
        }
    }
</style>